// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gk-0";
export var actionModalContentContainer = "_gk-1";
export var createTagButton = "_gk-2";
export var footerContainer = "_gk-7";
export var fullWidthDivider = "_gk-3";
export var hasCreateTagButton = "_gk-4";
export var noCreateTagButton = "_gk-5";
export var tagsContainer = "_gk-6";
export var tagsModalContentContainer = "_gk-8";